<script lang="ts" setup>
const model = defineModel<string | number | null>()

const props = defineProps<{
  placeholder?: string
}>()

const emit = defineEmits<{
  (e: 'enter'): void
  (e: 'onButtonClick'): void
}>()
</script>

<template>
  <div class="search-input-group relative">
    <SvgIcon
      class="search-icon pointer-events-none absolute left-4 top-3 cursor-pointer text-2xl"
      name="outlined/search"
      @click="emit('onButtonClick')"
    />

    <input
      ref="input"
      v-model="model"
      autocomplete="off"
      class="bg-white"
      :placeholder="placeholder"
      type="text"
      @keyup.enter="emit('enter')"
    >

    <SvgIcon
      v-if="model"
      class="absolute right-4 top-3 cursor-pointer text-2xl"
      name="outlined/close"
      @click="model = null"
    />
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.search-input-group {
  $icon-size: 24px;

  input {
    appearance: none;
    border: 1px solid color.mix(variables.$main-gray-color, white, 60%);
    border-radius: 12px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 24px;
    outline: none;
    padding: 11px 16px 11px calc(16px + $icon-size + 8px);
    transition: border .25s ease-in-out;
    width: 100%;

    &:focus,
    &:hover {
      border-color: variables.$main-green-color;
    }
  }

  svg.search-icon {
    color: color.mix(variables.$main-gray-color, white, 60%);
  }
}
</style>
